export const STACK_STRINGS = {
  // Empty state messages
  NO_DEFAULT_STACK: 'No Default Stack Found',

  // Button labels
  CREATE_DEFAULT_STACK: 'Create Default Stack',
  EDIT_DEFAULT_STACK: 'Edit Default Stack',

  // Modal titles
  MODAL_TITLE_CREATE: 'Create Stack',
  MODAL_TITLE_EDIT: 'Edit Stack',
  MODAL_TITLE_CREATE_DEFAULT: 'Create Default Stack',
  MODAL_TITLE_EDIT_DEFAULT: 'Edit Default Stack',

  // Success messages
  SUCCESS_CREATE: 'Stack created successfully',
  SUCCESS_UPDATE: 'Stack updated successfully',
  SUCCESS_CREATE_DEFAULT: 'Default stack created successfully',
  SUCCESS_UPDATE_DEFAULT: 'Default stack updated successfully',

  // Error messages
  ERROR_DEFAULT_STACK_EXISTS: 'Default stack already exists',
  ERROR_CREATE_DEFAULT: 'Failed to create default stack',
  ERROR_UPDATE_DEFAULT: 'Failed to update default stack',
  ERROR_CREATE: 'Failed to create stack',
  ERROR_UPDATE: 'Failed to update stack',
} as const;
